import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Output, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';

@Component({
  selector: 'smart-manage-thing-sensor-edit',
  templateUrl: './manage-thing-sensor-edit.component.html',
  styleUrls: ['./manage-thing-sensor-edit.component.scss','../../platform-color/platform-color.css']
})
export class ManageThingSensorEditComponent implements OnInit {
  submitted: boolean = false;
  loadPage: boolean = false;
  form: FormGroup;
  @Input()
  updateSensor: any;
  @Input()
  filter: any;
  sensorList: any = [];
  sensorType: any = [];

  sensorTab: number = 0;

  @Output() done = new EventEmitter<any>();
  @ViewChild("closeModal") private closeModal: ElementRef;
  constructor(
    private formBuilder: FormBuilder,
    private FarmService: FarmService,
    private spinner: NgxSpinnerService,

    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadPage = false;
    if(this.updateSensor){
      this.spinner.show();
      this.FarmService.getSensorType().subscribe(res=>{
        if(res.code == 200){
          this.sensorType = res.data.filter(sensor=> sensor.type == this.updateSensor.sensor_type);

          let data = {
            ...this.updateSensor,
            lat: this.updateSensor.coordinates.map_point.lat,
            lon: this.updateSensor.coordinates.map_point.lon,
            sensor_unit: this.updateSensor.sensor_unit == "null"? "": this.updateSensor.sensor_unit,
            img: "/"+this.updateSensor.sensor_img + ".png",
          }
          this.form.patchValue(data);
          this.reset();


          this.spinner.hide();
          this.loadPage = true;
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.updateSensor
    ) {
      this.createForm();
      this.ngOnInit();
    }
  }

  onChangeSensorType(value){
    
    if(value){
      if(value == 'RCPT'){
        this.form.get('auto_sync_flag').setValue(false);
      }
      this.spinner.show();
      this.FarmService.getSensorType().subscribe(res=>{
        if(res.code == 200){
          this.sensorType = res.data.filter(sensor=> sensor.type == value);

          this.spinner.hide();
        }
      });
    }
  }

  onChangeType(value){

    if(value){
      let sensor = this.sensorType.find(sensor=> sensor.code == value);

      this.form.get('sensor_unit').setValue(sensor.unit);
      if(sensor){
        if(sensor.icon && sensor.icon.length > 0){
          this.form.get('img').setValue(sensor.icon[0].normal);
          let sensor_img = sensor.icon[0].normal.split(".")[0];
  
          if(sensor_img.includes("/")){
            sensor_img = sensor_img.split("/")[1];
          }
          
          this.form.get('sensor_img').setValue(sensor_img);
        }else{
          this.form.get('img').setValue("");
        }
      }
    }
  }

  createForm(){
    this.form = this.formBuilder.group({
      type: this.formBuilder.control("", Validators.required),
      sensor_id: this.formBuilder.control(""),
      sensor_name: this.formBuilder.control("", Validators.required),
      sensor_desc: this.formBuilder.control(""),
      sensor_unit: this.formBuilder.control(""),
      sensor_img: this.formBuilder.control(""),
      sensor_type: this.formBuilder.control("", Validators.required),
      sensor_min: this.formBuilder.control(0, Validators.required),
      sensor_max: this.formBuilder.control(0, Validators.required),
      sensor_bottom_border: this.formBuilder.control(0, Validators.required),
      sensor_top_border: this.formBuilder.control(0, Validators.required),
      lat: this.formBuilder.control("", Validators.required),
      lon: this.formBuilder.control("", Validators.required),
      active: this.formBuilder.control(""),
      order_by: this.formBuilder.control(""),
      img: this.formBuilder.control(""),
      auto_sync_flag: this.formBuilder.control(false),
    });
  }


  get f() {
    return this.form.controls;
  }

  save(){
    this.submitted = true;

    if(this.form.invalid ||
      this.form.value.sensor_min > this.form.value.sensor_max ||
      this.form.value.sensor_bottom_border > this.form.value.sensor_top_border){
      return;
    }
    let sensor = this.form.value;

    let data = {
      org_id: sessionStorage.getItem('Org'),
      child_org_id: sessionStorage.getItem('ChildOrg'),
      thing_id: this.updateSensor.thing_id,
      thing_key: this.updateSensor.thing_key,
      farm_id: this.updateSensor.farm_id,
      plot_id: this.updateSensor.plot_id,
      sensor_bottom_border: sensor.sensor_bottom_border.toString(),
      sensor_top_border: sensor.sensor_top_border.toString(),
      sensor_id: sensor.sensor_id,
      sensor_img: sensor.sensor_img? sensor.sensor_img: "null",
      sensor_max: sensor.sensor_max.toString(),
      sensor_min: sensor.sensor_min.toString(),
      sensor_name: sensor.sensor_name,
      sensor_type: sensor.sensor_type,
      sensor_unit: sensor.sensor_unit? sensor.sensor_unit: "null",
      sensor_desc: sensor.sensor_name,
      active: sensor.active? "true": "false",
      sensor_widget_staus: sensor.active? "Y": "N",
      type: sensor.type,
      coordinates:{
        map_point:{
          lat: parseFloat(sensor.lat),
          lon: parseFloat(sensor.lon),
        }
      },
      _id: this.updateSensor._id,
      order_by: sensor.order_by,
      color: this.updateSensor.color,
      default: this.updateSensor.default,
      sensor_graph_staus: this.updateSensor.sensor_graph_staus,
      sensor_target_relay: this.updateSensor.sensor_target_relay,
      sensor_target_value: this.updateSensor.sensor_target_value,
      sensor_target_color: this.updateSensor.sensor_target_color,
      auto_sync_flag:sensor.auto_sync_flag,
    }
    this.FarmService.updateSensor(data).subscribe(res=>{
      if(res.code == 200){
        this.done.emit(
          true
        );
        this.createForm();
        this.closeModal.nativeElement.click();
      }
    })
  }

  close(){
    this.done.emit(
      false
    );
    this.createForm();
  }

  reset(){
    this.cd.detectChanges();
  }

  pinMap(e){
    if(e){
      this.form.get('lat').setValue(e.lat);
      this.form.get('lon').setValue(e.lng);
    }
  }
}
